import type { MutationTree } from 'vuex/types/index.js';
import { initialState as getInitialState } from '@/store/initialState/initialState';

export const APP_MUTATIONS: MutationTree<Record<string, unknown>> = {
  RESET_STATE(state): void {
    const initialState_ = getInitialState();
    Object.keys(initialState_).forEach((key: string) => {
      state[key] = initialState_[key];
    });
  },
};
